import { Outlet, createRootRoute, useLocation } from '@tanstack/react-router';
import MainSidebar from '../components/MainSidebar';
import MobileTabBar from '../components/MobileTabBar';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { FiltersProvider } from '../components/analytics/filters';
import { IsMobileProvider } from '../hooks/IsMobileContext';
import { useIsMobile } from '../hooks/useIsMobile';
import PasswordSyncAnnouncement from '../components/password-sync/PasswordSyncAnnouncement';

export const Route = createRootRoute({
  component: RootComponent,
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      retry: 1,
    },
  },
});

function RootComponent() {
  return (
    <IsMobileProvider>
      <RootInner />
    </IsMobileProvider>
  );
}

function RootInner() {
  const location = useLocation();
  const isMobile = useIsMobile();

  const publicRoutes = ['/login', '/password-reset', '/privacy-policy', '/terms-of-service'];
  const isPublicRoute = publicRoutes.some(route => location.pathname.startsWith(route));

  if (isPublicRoute) {
    return (
      <QueryClientProvider client={queryClient}>
        <div className="min-h-screen w-full bg-[url('/background2.png')] bg-cover bg-center font-sans">
          <Outlet />
        </div>
      </QueryClientProvider>
    );
  }

  return (
    <QueryClientProvider client={queryClient}>
      <FiltersProvider>
        <div className="flex min-h-screen w-full overflow-x-hidden bg-[url('/background2.png')] bg-cover bg-center font-sans">
          {!isMobile && <MainSidebar />}
          <main
            className="min-w-0 flex-1 overflow-hidden"
            style={
              isMobile
                ? { paddingLeft: '1rem', paddingRight: '1rem', paddingBottom: '6rem' }
                : { paddingLeft: '220px', paddingRight: '7rem' }
            }
          >
            <PasswordSyncAnnouncement />
            <Outlet />
          </main>
          {isMobile && <MobileTabBar />}
        </div>
      </FiltersProvider>
    </QueryClientProvider>
  );
}
